<template>
	<div class="principal">
		<div class="spinner" v-if="!dataGrafico">
			<v-progress-circular
				:size="50"
				color="primary"
				indeterminate
			></v-progress-circular>
		</div>
		<div class="grafico">
			<div v-if="dataGrafico">
				<trading-vue
					ref="tradingVue"
					:indexBased="true"
					:data="dataGrafico"
					:title-txt="getEspecie"
					:toolbar="true"
					:overlays="overlays"
					:width="width"
					:height="height"
					:color-back="colors.back"
					:color-grid="colors.grid"
					:color-text="colors.text"
					:color-cross="colors.cross"
					:color-candle-dw="colors.candle_dw"
					:color-wick-dw="colors.wick_dw"
					:color-title="colors.tvTitle"
				>
				</trading-vue>
			</div>
		</div>

		<div
			:class="['footer-grafico', !night ? 'light-mode' : '']"
			v-if="dataGrafico"
		>
			<!-- <v-btn
					color="transparent"
					size="x-small"
					class="white--text text-left"
					@click="cambiarDarkNightMode()"
				>
					Light/Night Mode
				</v-btn> -->
			<v-btn
				size="x-small"
				color="transparent"
				class="custom-button"
				@click="cambiarDarkNightMode()"
			>
				<v-icon color="#808080">mdi-weather-night</v-icon>
			</v-btn>
			<!-- class=".justify-start p0" -->

			<div class="text-center">
				<v-dialog v-model="dialog" width="300">
					<template v-slot:activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on" class="boton-rango"
							>Establecer rango de datos</span
						>
					</template>

					<template>
						<div class="contenedor-calendario">
							<v-date-picker
								v-model="dates"
								range
								locale="es-AR"
								selected-items-text="Multi-selector de fechas"
							>
								<v-spacer></v-spacer>
								<v-btn
									text
									color="primary"
									@click="enviarFechasLimite()"
								>
									OK
								</v-btn>
							</v-date-picker>
						</div>
					</template>
				</v-dialog>
			</div>
			<div class="selector">
				<v-select
					dense
					v-model="input.zoom_id"
					:items="items"
					item-value="id"
					v-on:change="actualizarZoom()"
					item-text="name"
					:menu-props="{ top: true, offsetY: true }"
					label="Zoom"
				></v-select>
			</div>
		</div>
	</div>
</template>
<script>
import { DataCube } from "trading-vue-js";
import TradingVue from "trading-vue-js";
import axios from "axios";
import FormData from "form-data";
import moment from "moment";

export default {
	name: "MainChart",
	components: { TradingVue },

	data: () => ({
		overlays: [],
		night: true,
		//data que va a renderizar el vue trading ya con el datacube dentro
		dataGrafico: null,
		//data que viene de la api que se usa posteriormente para mapearla y devolverla al datacube
		historico: null,
		width: 320,
		height: 480,
		//datos para hacer el req a la api
		dataApiArray: [
			["fecha_inicio", "0000-00-00"],
			[
				"fecha_fin",
				new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
					.toISOString()
					.substr(0, 10),
			],
			["offset", "0"],
			["orden", "asc"],
			["avanzado", "1"],
		],
		//array con fechas del calendario. inicializa vacio
		dates: [],
		dialog: false,
		items: [
			{ id: 0, name: "10 dias" },
			{ id: 1, name: "1 mes" },
			{ id: 2, name: "1 año" },
			{ id: 3, name: "YTD" },
			{ id: 4, name: "MAX" },
		],
		itemsVelas: [
			{ id: 0, name: "Por día" },
			{ id: 1, name: "Por semana" },
			{ id: 2, name: "Por mes" },
		],
		input: {
			zoom_id: 0,
			velas: 0,
		},
		// ultimoZoomElegido: 1,
	}),
	created() {
		this.callApi();
	},

	mounted() {
		window.addEventListener("resize", this.screen);
		this.screen();
		document.title = this.$route.params.especie + " | Rava Graficos";
	},
	methods: {
		actualizarVelas(rendering) {
			let valorVelas = rendering ? 0 : this.input.velas;
			const datosAgrupadosPorSemana = [];
			if (valorVelas !== 0) {
				// Crear un nuevo array para almacenar los datos agrupados

				// Variables para mantener el seguimiento de la semana actual
				let inicioSemana = 0;
				let finSemana = 0;
				let volumenTotal = 0;

				// Iterar sobre los datos originales
				for (let i = 0; i < this.historico.grafico.length; i++) {
					const dato = this.historico.grafico[i];

					// Obtener el timestamp del dato actual
					const timestamp = dato[0];

					// Verificar si el dato está en la misma semana que el anterior
					if (
						i > 0 &&
						this.esMismaSemanaMes(
							timestamp,
							this.historico.grafico[i - 1][0],
							valorVelas
						)
					) {
						// Actualizar fin de semana y sumar al volumen total
						finSemana = timestamp;
						volumenTotal += dato[5]; // Sumar al volumen total
					} else {
						// Nuevo comienzo de semana
						inicioSemana = timestamp;
						finSemana = timestamp;
						volumenTotal = dato[5]; // Iniciar volumen total

						// Crear un nuevo objeto agrupado
						const datoAgrupado = [
							inicioSemana, // timestamp de inicio de semana
							this.historico.grafico[i][1], // apertura del primer día
							dato[2], // máximo de la semana
							dato[3], // mínimo de la semana
							this.historico.grafico[i][4], // cierre del último día
							volumenTotal, // volumen total de la semana
						];

						// Agregar el objeto agrupado al nuevo array
						datosAgrupadosPorSemana.push(datoAgrupado);
					}
				}
			}
			// return datosAgrupadosPorSemana;
			this.dataGrafico = new DataCube({
				ohlcv:
					valorVelas === 0
						? this.historico.grafico
						: datosAgrupadosPorSemana,

				onchart: [
					{
						name: "EMA, 21",
						type: "EMA",
						data: this.historico.ma21,
						settings: { lineWidth: 2.5 },
					},
					{
						name: "EMA, 42",
						type: "EMA",
						data: this.historico.ma42,
						settings: { lineWidth: 2.5 },
					},
					{
						name: "EMA, 200",
						type: "EMA",
						data: this.historico.ma200,
						settings: { color: "red", lineWidth: 2.5 },
					},
				],
				offchart: [
					{
						name: "MACD",
						type: "Splines",
						data: this.historico.macd,
						settings: {},
					},
					{
						name: "Estocastico",
						type: "Splines",
						data: this.historico.estocastico,
						settings: {},
					},
				],
			});
		},

		esMismaSemanaMes(timestamp1, timestamp2, valorVelas) {
			// por semana
			if (valorVelas === 1) {
				// Función para verificar si dos timestamps están en la misma semana
				const unaSemanaEnMillis = 7 * 24 * 60 * 60 * 1000;
				return Math.abs(timestamp1 - timestamp2) < unaSemanaEnMillis;

				//por mes
			} else {
				// Obtener los objetos de fecha correspondientes a los timestamps
				const fecha1 = new Date(timestamp1);
				const fecha2 = new Date(timestamp2);

				// Comparar si están en el mismo mes
				return fecha1.getMonth() === fecha2.getMonth();
			}
		},
		actualizarZoom() {
			let valor2 = this.historico.grafico[
				this.historico.grafico.length - 1
			][0];
			let valor1;
			switch (this.input.zoom_id) {
				case 0:
					valor1 = parseInt(
						moment(valor2)
							.subtract(10, "days")
							.format("x")
					);
					this.input.velas = 0;
					break;
				case 1:
					valor1 = parseInt(
						moment(valor2)
							.subtract(1, "month")
							.format("x")
					);
					// this.input.velas = 1;
					this.input.velas = 0;
					break;
				case 2:
					valor1 = parseInt(
						moment(valor2)
							.subtract(1, "year")
							.format("x")
					);
					this.input.velas = 2;
					break;
				case 3:
					valor1 = parseInt(
						moment(valor2)
							.startOf("year")
							.format("x")
					);
					this.input.velas = 2;
					break;

				default:
					valor1 = this.historico.grafico[0][0];
					this.input.velas = 2;
					break;
			}

			//inicializa el calendario con las dos fechas limites

			//se formatean las fechas
			let fechaInicial = moment(valor1).format("YYYY-MM-DD");
			let fechaFinal = moment(valor2).format("YYYY-MM-DD");

			// //se asignan las fechas al array de dates de calendario
			this.dates[0] = fechaInicial;
			this.dates[1] = fechaFinal;
			this.enviarFechasLimite();
			this.actualizarVelas(false);
		},
		cerrarCalendario() {
			this.dialog = false;
		},
		enviarFechasLimite() {
			let start = parseInt(moment(this.dates[0]).format("x"));
			let end = parseInt(moment(this.dates[1]).format("x"));
			this.$nextTick(() =>
				//necesita timestamp en formato Number
				this.$refs.tradingVue.setRange(start, end)
			);
			this.dialog = false;
		},
		//llamado a la api
		async callApi() {
			const form_data = new FormData();
			form_data.append("especie", this.getEspecie);
			this.dataApiArray.forEach((element) => {
				form_data.append(element[0], element[1]);
			});
			try {
				let res = await axios.post(
					"https://admin.rava.com/api/v3/publico/cotizaciones/historicos",
					form_data,
					{}
				);
				this.historico = res.data.body;
				//dataGrafico se renderiza
				this.dataGrafico = new DataCube(this.dataChart);
			} catch (error) {
				console.log(error);
			}
			this.setDates();
			this.enviarFechasLimite();
			this.actualizarVelas(true);
		},
		setDates() {
			//inicializa el calendario con las dos fechas limites
			let valor2 = this.historico.grafico[
				this.historico.grafico.length - 1
			][0];
			let valor1 = parseInt(
				moment(valor2)
					.subtract(10, "day")
					.format("x")
			);
			//se formatean las fechas
			let fechaInicial = moment(valor1).format("YYYY-MM-DD");
			let fechaFinal = moment(valor2).format("YYYY-MM-DD");

			//se asignan las fechas al array de dates de calendario
			this.dates[0] = fechaInicial;
			this.dates[1] = fechaFinal;
		},
		screen() {
			let body = document.querySelector("body");
			this.width = body.offsetWidth;
			// this.height = body.offsetHeight - 1;
			this.height = body.offsetHeight - 40;
		},
		datos() {
			let datos = [
				"grafico",
				"macd",
				"estocastico",
				"ma21",
				"ma42",
				"ma200",
			];
			return datos;
		},
		cambiarDarkNightMode() {
			this.night = !this.night;
		},
	},

	computed: {
		getEspecie() {
			let especie = this.$route.params.especie;
			especie.replaceAll("%20", " ");
			return especie;
		},
		colors() {
			return this.night
				? {
						back: "#121827",
						grid: "#3e3e3e",
						text: "#35a776",
						cross: "#dd64ef",
						candle_dw: "#e54077",
						wick_dw: "#e54077",
				  }
				: {
						back: "#fff",
						grid: "#eee",
						text: "#333",
						candle_dw: "#e54077",
						wick_dw: "black",
				  };
		},
		//se retorna en modo de objeto que requiere el datacube
		dataChart() {
			return {
				ohlcv: this.historico.grafico,
				onchart: [
					{
						name: "EMA, 21",
						type: "EMA",
						data: this.historico.ma21,
						settings: { lineWidth: 2.5 },
					},
					{
						name: "EMA, 42",
						type: "EMA",
						data: this.historico.ma42,
						settings: { lineWidth: 2.5 },
					},
					{
						name: "EMA, 200",
						type: "EMA",
						data: this.historico.ma200,
						settings: { color: "red", lineWidth: 2.5 },
					},
				],
				offchart: [
					{
						name: "MACD",
						type: "Splines",
						data: this.historico.macd,
						settings: {},
					},
					{
						name: "Estocastico",
						type: "Splines",
						data: this.historico.estocastico,
						settings: {},
					},
				],
			};
		},
	},
};
</script>
<style>
.night-mode {
	color: #888;
	font: 11px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
}
.principal {
	height: 100%;
}
.spinner {
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.footer-grafico {
	/* color: #131722; */
	background: #121827;
	border-color: rgb(80, 80, 80);
	width: 100%;
	height: 40px;
	display: flex;
	align-items: center;
	position: fixed;
	padding-left: 48px;
}
.contenedor-calendario {
	display: flex;
	flex-direction: column;
	/* width: 100px; */
}
.boton-rango {
	color: gray !important;
	font-size: 18px;
}
.selector {
	margin-left: 20px;
	height: 30px;
}
.v-label {
	color: gray !important;
}
.v-select__selections {
	color: gray !important;
}
.light-mode {
	background-color: white;
}
.custom-button {
	min-width: 0 !important;
	margin-right: 8px;
}
</style>
